import { createSharedComposable } from '@vueuse/shared';
import { useApiClient } from '@/app/core/api-client';
import type { PaginationQuery } from '@/app/shared/types';

import type { AccountSettings, AssociatedAccount, Upload } from '../../types';

export const useAccountApi = createSharedComposable(() => {
  const { createMethod } = useApiClient();

  const getAccountSettings = createMethod<[], AccountSettings>(async (transport) => {
    const { data } = await transport.get<AccountSettings>('v1/account');
    return data;
  });

  const getAssociatedAccounts = createMethod<[], AssociatedAccount[]>(async (transport) => {
    const { data } = await transport.get<AssociatedAccount[]>('/v1/user/associated_accounts');
    return data;
  });

  const assignAssociatedAccount = createMethod<[string]>(async (transport, id) => {
    await transport.post(`/v1/user/associated_accounts/${id}/assign`, {});
  });

  const getUploads = createMethod<[params?: PaginationQuery], Upload[]>(async (transport, params) => {
    const { data } = await transport.get<Upload[]>('/v1/uploads', { params });
    return data;
  });

  return {
    getAccountSettings,
    getAssociatedAccounts,
    assignAssociatedAccount,
    getUploads,
  };
});
